import history from 'config/history';
import {
  AUTH_LOGIN_ROUTE,
  AUTH_TOKEN_STORAGE_KEY,
  LOGGED_IN_USER_SUB_ID,
  REFRESH_TOKEN_STORAGE_KEY,
} from 'constants/authentication';
import * as Sentry from '@sentry/react';
import { analyticsClient } from '@spotted-zebra-uk/ui-components';
import { shutdownIntercom } from './intercom';

export const setAccessToken = (accessToken: string) => {
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, accessToken);
};

export const getAccessToken = () => {
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
};

export const removeAccessToken = () => {
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
};

export const setRefreshToken = (refreshToken: string) => {
  localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
};

export const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);
};

export const removeRefreshToken = () => {
  localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
};

export const authCleanup = () => {
  removeAccessToken();
  removeRefreshToken();
  shutdownIntercom();
};

export const getLoggedInUserSubId = () => {
  return localStorage.getItem(LOGGED_IN_USER_SUB_ID);
}

export const setLoggedInUserSubId = (subId: string) => {
  localStorage.setItem(LOGGED_IN_USER_SUB_ID, subId)
}

export const logoutCleanup = () => {
  authCleanup();
  history.push(AUTH_LOGIN_ROUTE);
  analyticsClient.resetIdentity();
  Sentry.setUser(null);
};
